import styled from 'styled-components';

import { darken } from 'polished';

export const QuestionWrapper = styled.div`
    max-width: 100%;
    background: var(--blue);
    display: grid;
    justify-content: center;
    padding: 80px;

    h1 {    
        font-size:36px;
        color: var(--white);
        font-weight: 600;
    }

    p {
        font-size:28px;
        color: var(--white);
        font-weight: 600;
        text-align: center;
        margin: 5px 0 25px 0;
    }

    h6 {
        color: var(--white-opacity);
        text-align: end;
        padding: 10px 10px;
    }

    div {
        display: flex;

        input {
            border-radius: 50px;
            padding: 10px 25px 10px 25px;
            background: var(--blue-dark);
            color: var(--white);
            border:0;
            width: 300px;
            font-size: 14px;
            font-weight: 600;

        }

        button {
            margin-left: 10px;
            background: var(--orange);
            border: 0;
            border-radius: 50px;
            color: var(--white);
            padding: 10px 25px 10px 25px;
            font-weight: 600;
            transition: 0.3s;

            &:hover {
                background: ${darken(0.1, '#e65a25')}
            }
        }
    }

    @media (max-width: 700px) {
        h1 {
            font-size: 26px;
            text-align: center;
        }

        p {
            font-size:22px;
        }

        div {
            display:grid;
            justify-content:center;
            width: 100%;
            input {
                border-radius:0;
            }

            button {
                margin-left: 0px;
                border-radius:0;
            }

         } 
            h6 {
                text-align: center;
            }
    }

    @media (max-width: 520px) {
        h1 {
            font-size: 24px;
            text-align: center;
        }
    }
`;
